import React, { useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";
import Header from "../../../components/Header/Header";
import images from "../../../images";
import Button from "../../../components/common/Button/Button";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import {
  addObjectiveManual,
  updateObjectiveManual,
} from "../../../redux/featuresSlice/commonSlice";
import { useTranslation } from "react-i18next";

const ManualInput = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const location = useLocation();

  const [objective, setObjective] = useState("");
  const objectiveToEdit = location.state?.objectiveToEdit;
  const limit = location.state?.limit; // Get limit from navigation state

  useEffect(() => {
    if (objectiveToEdit) {
      setObjective(objectiveToEdit.name || "");
    }
  }, [objectiveToEdit]);

  const handleSave = () => {
    if (objective.trim()) {
      if (objectiveToEdit) {
        // Edit existing objective
        const updatedObjective = {
          ...objectiveToEdit,
          name: objective.trim(),
        };
        dispatch(updateObjectiveManual(updatedObjective));
      } else {
        // Add new objective
        const newObjective = {
          id: uuidv4(),
          name: objective.trim(),
        };
        dispatch(addObjectiveManual(newObjective));
      }

      setObjective("");
      navigate("/ondemand", { state: { limit } }); // Pass limit back
    }
  };

  return (
    <div className="flex flex-col mx-auto w-full max-w-[480px] bg-gray-100 min-h-[100vh]">
      <div className="fixed top-0 left-0 w-full z-50 flex justify-center items-center">
        <Header
          subTitle={t("quest.manualInput.questDesign")}
          subTitleIcon={images.ThreeDotIcon}
          className={"justify-end max-w-[480px]"}
        />
      </div>
      <div className="h-16"></div>
      <button
        onClick={() => navigate("/ondemand", { state: { limit } })}
        className="px-4"
      >
        <img src={images.BackIconBlack} alt="" className="w-[42px]" />
      </button>
      <div className="p-4">
        <div className="bg-white p-2 rounded-md">
          <h1 className="font-medium">
            {objectiveToEdit
              ? t("quest.manualInput.editYourObjective")
              : t("quest.manualInput.describeYourObjective")}
          </h1>
          <textarea
            className="flex-1 shrink gap-2.5 px-3 focus:outline-none pt-3 pb-28 mt-4 w-full text-base rounded-xl border border-solid border-stone-200 min-h-[142px] text-zinc-800"
            placeholder={t("quest.manualInput.mapOutCustomerJourney")}
            aria-label="Question input"
            value={objective}
            onChange={(e) => setObjective(e.target.value)}
          />
        </div>

        <Button
          className="px-5 py-4 w-full text-base font-semibold text-white bg-[#3F54DF] rounded-xl cursor-pointer h-[54px]"
          text={objectiveToEdit ? t("base.update") : t("base.save")}
          onClick={handleSave}
        />
      </div>
    </div>
  );
};

export default ManualInput;
